import {SegmentedControl, type SegmentedControlOption} from "../../general/SegmentedControl.tsx";
import {fieldLabelClasses} from "../../general/fieldStyles.ts";
import PeriodicPnlView, {type PeriodicPnlViewProps} from "./PeriodicPnlView.tsx";
import PeriodicBalanceSheetView, {type PeriodicBalanceSheetViewProps} from "./PeriodicBalanceSheetView.tsx";

export type PerMonthStatement = "profit-and-loss" | "balance-sheet";

const STATEMENT_OPTIONS: SegmentedControlOption<PerMonthStatement>[] = [
    {value: "profit-and-loss", label: "Winst & verlies"},
    {value: "balance-sheet", label: "Balans"},
];

export function isPerMonthStatement(value: string | null): value is PerMonthStatement {
    return STATEMENT_OPTIONS.some((option) => option.value === value);
}

interface PerMonthViewProps
    extends Omit<PeriodicPnlViewProps, "toolbarLeading">,
        Pick<PeriodicBalanceSheetViewProps, "fetchBalanceSheetPerPeriod"> {
    statement: PerMonthStatement;
    onStatementChange: (statement: PerMonthStatement) => void;
    canSeeBalanceSheet: boolean;
}

export default function PerMonthView({
    statement,
    onStatementChange,
    canSeeBalanceSheet,
    fetchProfitAndLossPerPeriod,
    fetchBalanceSheetPerPeriod,
    ...shared
}: PerMonthViewProps) {
    const statementSwitch = canSeeBalanceSheet ? (
        <div className="flex flex-col gap-1.5">
            <span className={fieldLabelClasses}>Overzicht</span>
            <SegmentedControl
                value={statement}
                options={STATEMENT_OPTIONS}
                onChange={onStatementChange}
                ariaLabel="Overzicht"
            />
        </div>
    ) : null;

    if (canSeeBalanceSheet && statement === "balance-sheet") {
        return (
            <PeriodicBalanceSheetView
                {...shared}
                fetchBalanceSheetPerPeriod={fetchBalanceSheetPerPeriod}
                toolbarLeading={statementSwitch}
            />
        );
    }
    return (
        <PeriodicPnlView
            {...shared}
            fetchProfitAndLossPerPeriod={fetchProfitAndLossPerPeriod}
            toolbarLeading={statementSwitch}
        />
    );
}
